{
  "chapel": {
    "u0": -16,
    "chordU": 19.5,
    "vc": 25.4,
    "half": 4.4,
    "eaveY": 11.4,
    "ridgeY": 17.1,
    "apse": "flat"
  },
  "ranges": [
    {
      "id": "court-rokin-range",
      "u": -11.3,
      "v": -3.25,
      "angleDeg": -90,
      "length": 48.5,
      "width": 6,
      "eaves": 8.8,
      "ridge": 13.4,
      "floors": 2,
      "bays": 9,
      "roof": "slate",
      "passage": 0,
      "windowRows": [
        {
          "sill": 0.9,
          "top": 4.5,
          "width": 1.8,
          "pointed": true
        },
        {
          "sill": 5.5,
          "top": 7.9
        }
      ],
      "roofGables": {
        "centres": [-21, -14, -7, 0, 7, 14, 21],
        "halfWidth": 0.8,
        "v0": 0.9,
        "v1": 3,
        "eaves": 12.2,
        "ridge": 13.5,
        "sill": 10.1,
        "top": 11.1
      }
    },
    {
      "id": "outer-rokin-range",
      "u": -16,
      "v": -3.25,
      "angleDeg": -90,
      "length": 48.5,
      "width": 3.5,
      "eaves": 7.8,
      "ridge": 10.6,
      "floors": 2,
      "bays": 9,
      "roof": "tile",
      "passage": 0
    },
    {
      "id": "nes-gate-wing",
      "u": 18.75,
      "v": 8,
      "angleDeg": 90,
      "length": 25,
      "width": 1.5,
      "eaves": 3,
      "ridge": 3.6,
      "floors": 1,
      "bays": 6,
      "roof": "tile",
      "passage": 3,
      "passageU": -7,
      "blindSides": [0, 1, 2, 3]
    },
    {
      "id": "southern-nes-house",
      "u": 11.5,
      "v": -22,
      "angleDeg": 0,
      "length": 21,
      "width": 8,
      "eaves": 8.3,
      "ridge": 13.3,
      "floors": 2,
      "bays": 5,
      "roof": "slate",
      "passage": 0
    },
    {
      "id": "court-cross-house",
      "u": 12,
      "v": -12,
      "angleDeg": 0,
      "length": 18,
      "width": 7,
      "eaves": 7.5,
      "ridge": 11.7,
      "floors": 2,
      "bays": 4,
      "roof": "tile",
      "passage": 0
    },
    {
      "id": "southern-rokin-house",
      "u": -12,
      "v": -32,
      "angleDeg": 0,
      "length": 10,
      "width": 8,
      "eaves": 7.2,
      "ridge": 10.7,
      "floors": 2,
      "bays": 3,
      "roof": "tile",
      "passage": 0
    }
  ],
  "court": [
    [-7.9, -27.7],
    [-6.5, -27.7],
    [-6.5, -35.5],
    [0.6, -35.5],
    [0.6, -17.7],
    [2.6, -17.7],
    [2.6, -8.1],
    [17.7, -8.1],
    [17.7, 20.6],
    [-7.9, 20.6]
  ],
  "green": [
    [-6.5, -26.8],
    [-0.5, -26.8],
    [-0.5, -7],
    [15.5, -7],
    [15.5, 18.5],
    [-6.5, 18.5]
  ],
  "walls": [
    {
      "from": [-17.6, -37],
      "to": [22, -37],
      "width": 0.35,
      "height": 2.2
    },
    {
      "from": [-17.6, -37],
      "to": [-17.6, -27.5],
      "width": 0.3,
      "height": 2.2
    },
    {
      "from": [22, -37],
      "to": [22, -26],
      "width": 0.3,
      "height": 2.2
    },
    {
      "from": [22, -18],
      "to": [22, -15.5],
      "width": 0.3,
      "height": 2.2
    },
    {
      "from": [21, -8.5],
      "to": [21, -4.5],
      "width": 0.3,
      "height": 2.2
    },
    {
      "from": [21, -4.5],
      "to": [19.5, -4.5],
      "width": 0.3,
      "height": 2.2
    }
  ],
  "note": "The painting and 1544 woodcut guide separate northern chapel, unequal paired Rokin roofs, lower Nes enclosure, distinct southern houses and open green court. The 1729 Le Long print and 1733 De Haen drawing help interpret the masses; the 1760 Rijksmuseum catalogue expressly derives that later reconstruction from Anthonisz. 1544, so later views do not provide independent medieval measurements. Ornate later domestic gables are not imported. All dimensions, axis fits, heights, window forms, bays, gablet count, parallel outer wing, hidden elevations, walls, court boundary and Nes passage are estimated. The roughly 2760 square metre dry core is provisional, not the complete recovered property. The western Spoey was covered in 1505; the northern chapel crosses its inferred alignment without an open trench through the court. Exact hidden vault, cemetery location, hospital rooms and annex functions remain unresolved. Kalfsvelsteeg street houses stay outside this core. No later public Cellebroerssteeg or Wijde Lombardsteeg is drawn through the standing convent."
}
